import ActiveService from '@/service.active';
import { update } from '@/refference.helper';
import {isInteger} from "lodash";

const INVOICE_ACCOUNTS_URI = '/api/invoiceaccounts';
const API_URL = process.env.API_URL || 'http://localhost:3000';

class AuthService extends ActiveService{
  /**
   *
   * @param $injector
   * @param CONFIG
   * @param $translates
   * @param $httpConfigurator
   */
  constructor(
    $injector,
    CONFIG,
    $translates,
    $httpConfigurator,
    $channel
  ){
    'ngInject';
    super( $injector );
    this.CONFIG = CONFIG;
    this.$translates = $translates;
    this.$httpConfigurator = $httpConfigurator;
    this.company = null;
    this._company$ = this.$q.defer();
    this.company$ = this._company$.promise;

    this.$channel = $channel;

    if(this.isAuthenticated()){
      this.$httpConfigurator.setHeaders(this.getToken());
      this.invoiceAccounts$ = this.getInvoiceAccounts();
      this.invoiceAccounts$.then(
          data => {
            this.invoiceAccounts = data;
            this.defaultInvoiceAccount = this.invoiceAccounts.find(account => account.default_account === true);
          }
      );
      this.getUser$(true).then(user => {
        this.user = user;
        this.activeGet(this.user.company)
          .then(company => {
            this._company$.resolve(company);
            this.company = company;
          });
      });
    }
  }

  /**
   *
   * @param state
   * @returns {boolean}
   */
  isNull( state ){
    return null != state;
  }

  /**
   *
   * @returns {boolean}
   */
  isAuthenticated(){
    return this.isNull(this.getToken());
  }

  logout(){
    return this.activePost( this.CONFIG.API.logout, {} )
      .then(() => {
        this.$httpConfigurator.clearHeaders();
        this.cacheRemove('user');
        this.cacheRemove('company');
        this.cacheRemove('token');
      });
  }

  /**
   *
   * @returns {*}
   */
  getUser(){
    let user = this.cacheGet('user');
    update(this.user, user);
    return user;
  }

  getUser$(force = false) {
    let deferred = this.$q.defer();

    let user = this.cacheGet('user');
    if (user && !force) {
      update(this.user, user);
      deferred.resolve(user);
    } else {
      this.me().then(() => {
        user = this.cacheGet('user');
        deferred.resolve(user)
      });
    }
    return deferred.promise;
  }

  /**
   *
   * @param user
   * @returns {*}
   */
  setUser( user ){
    return this.cacheSet('user', user);
  }

  getToken(){
    return this.cacheGet('token');
  }

  setToken(token){
    return this.cacheSet('token', token);
  }

  getInvoiceAccounts() {
    return this.activeGet(INVOICE_ACCOUNTS_URI);
  }

  saveMe(data) {
    return this.activePut(this.getUser().uri, data)
      .then( user => {
        this.getUser$(true);
      });
  }

  /**
   *
   * @returns {*|Promise.<TResult>}
   */
  me(){
    return this.activeGet('/api/users/me')
      .then( user => {
        user.uris.Avatar = `${user.uris.Avatar}?timestamp=${Number(new Date())}`;
        this.setUser( user );
        this.user = this.getUser();
        this.user.uris.Avatar = user.uris.Avatar;
        this.$translates.setLanguage(this.user.lang);
      } );
  }
  /**
   *
   * @param data
   * @returns {Function}
   */
  authenticate( data ){
    return this.activePost( this.CONFIG.API.login , data )
      .then( user => {
        this.setToken(user.session_data.session_id);
        this.setUser(user);
        this.$httpConfigurator.setHeaders(this.getToken());
        this.user = this.getUser();
      } )
      .catch(() => this.notify.set(this.$translates.get('SIGNIN_ERROR'), 'error'));
  }

  userHasRole(code) {
    return this.user && this.user.role && this.user.role.code.toLowerCase() === code.toLowerCase();
  }

  changeLang(lang = 'pl'){
		const user = this.getUser();
		if (user) {
      user.lang = lang;
      this.saveMe(user)
        .then(user => {
          console.log(user);
          this.$translates.setLanguage(lang);
          location.reload();
        });
    } else {
		  this.$translates.setLanguage(lang);
		  location.reload();
    }
  }

}

export default AuthService;



/** WEBPACK FOOTER **
 ** ./frontend/common/services/auth.service.js
 **/